export function getCustomFieldDataId(customField) {
    return customField.getAttribute('data-id');
}

export function isCustomFieldEntered(customField) {
    const csfValues = AMOCRM.data.current_card.model.attributes;
    const dataId = getCustomFieldDataId(customField);
    return Boolean(csfValues[`CFV[${dataId}]`]);
}